import * as React from 'react';
import styled from 'styled-components';

import { ModuleError } from '@packages/common';
import { MultilineText } from '../../MultilineText/MultilineText';

export const Container = styled.div`
  border: 1px solid #f5c6cb;
  padding: 16px;
  text-align: center;
  overflow: hidden;
  color: #721c24;
  background-color: #f8d7da;
`;

export type ErrorProps = ModuleError;

export const Error: React.FC<ErrorProps> = ({ message }) => (
  <Container>
    <MultilineText>{message}</MultilineText>
  </Container>
);
